import { Collapse, Form, Typography } from "antd";

import { FormInstance } from "antd/lib/form";
import { useGetGeneralField } from "@src/hooks/ab-testing/use-get-general-field";
import { ControlInput, ControlInputInstance } from "./controll-input";
import React from "react";
import { useResizeObserver } from "usehooks-ts";
import { FunnelChartContainerWrapperMemo } from "./funnel-chart-container";
import { EventListDataType, sortListEventNameByName } from "@src/util/ab-testing/funnel/manage-state-event-lists";

export type ApplyValueStateType = {
  timeRange: string[] | null;
  breakdownBy: string | null;
  breakdownValues: string[] | null;
  eventLists: EventListDataType[] | null;
  filters?: { field: string; operator: string; value: any }[];
};

export const FunnelExploration: React.FC<{ form: FormInstance }> = ({ form }) => {
  const { variants_options } = useGetGeneralField({ form });

  const cacheApplyValue = React.useRef<ApplyValueStateType>();
  const [applyValue, setApplyValue] = React.useState<ApplyValueStateType>({
    timeRange: null,
    breakdownBy: null,
    breakdownValues: null,
    eventLists: null,
    filters: undefined,
  });
  const [forceResetTable, setForceResetTable] = React.useState(false);
  const variantsOption = variants_options ?? [];

  const handleApply = (values: ApplyValueStateType) => {
    function checkDiff(values1: ApplyValueStateType | undefined, values2: ApplyValueStateType | undefined) {
      if (!values1 || !values2) return true;
      return (
        JSON.stringify({
          ...values1,
          eventLists: sortListEventNameByName(values1.eventLists ?? [])
            .map((item) => item.name)
            .filter((f) => !!f),
        }) !==
        JSON.stringify({
          ...values2,
          eventLists: sortListEventNameByName(values2.eventLists ?? [])
            .map((item) => item.name)
            .filter((f) => !!f),
        })
      );
    }
    if (checkDiff(cacheApplyValue.current, values)) {
      setForceResetTable(true);
    }
    setApplyValue(values);
    cacheApplyValue.current = values;
  };

  const containerRef = React.useRef<HTMLDivElement>(null);
  const { width = 0 } = useResizeObserver({
    ref: containerRef,
    box: "border-box",
  });
  return (
    <>
      <ControlInputInstance />

      <Collapse
        className="ab-testing-collapse mb-4"
        items={[
          {
            key: "funnel-exploration",
            label: <Typography.Text strong>User Conversion</Typography.Text>,
            children: (
              <div ref={containerRef} className="">
                <ControlInput handleApply={handleApply} applyValue={applyValue} form={form} />

                <div
                  style={{
                    display: applyValue.eventLists ? "block" : "none",
                  }}
                >
                  <FunnelChartContainerWrapperMemo
                    form={form}
                    containerWidth={width}
                    chartWidth={Math.max(300, Math.ceil(width / variantsOption.length))}
                    applyValue={applyValue}
                    setForceResetTable={setForceResetTable}
                    forceResetTable={forceResetTable}
                  />
                </div>
              </div>
            ),
          },
        ]}
      />
    </>
  );
};
